module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_DE_Düngekarten.c6c3620f.pdf";